// sessionStorage
const session = {
  /** sessionStorage **/
  // set
  set(key, val) {
    if(val == undefined) return
    sessionStorage.setItem(key, JSON.stringify(val))
  },
  // get
  get(key) {
    try {
      return JSON.parse(sessionStorage.getItem(key))
    } catch (error) {
      return null
    }
  },
  // remove
  remove(key) {
    sessionStorage.removeItem(key)
  },
  // clear
  clear() {
    sessionStorage.clear()
  },
}

export default session
